<template>
  <div v-if="getRole('Consultar')">
    <div class="row" v-if="getRole('Consultar')">
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3">
                      <div class="col-6">
                        <form class="form-inline">
                          <div class="form-group mr-2">
                            <label for="productssearch-input" class="sr-only">Buscar</label>
                            <input type="search" class="form-control border-light" id="productssearch-input"
                              placeholder="Buscar..." />
                          </div>
                          <button type="button" class="btn btn-primary mb-2 mb-sm-0">
                            <i class="mdi mdi-search-web"></i>
                          </button>
                          
                        </form>
                      </div>
                      <div class="col-6"></div>
                    </div>

                    <div class="table-responsive">
                      <table class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                        <thead >
                          <tr>
                            
                            <th class="text-center align-middle">Ver archivo</th>
                            <th class="text-center align-middle">Acciones</th>
                          </tr>
                        </thead>
                        <tbody  class="bg-white divide-y divide-gray-200">
                          <tr v-for="dato in lista" :key="dato.id">
                            
                           
                           <td class="text-center align-middle">
                            <div v-if="dato.file === null">
                            <h6>No hay archivo disponible
                            </h6></div>
                            <div v-else>
                           <button style=" background-color: transparent !important; border: none;" type="button" @click="gotoDigitalOcean(`${dato.file}`)"> <i class="mdi mdi-cloud-download"></i>
                           </button></div>
                            </td>
                            
                              <td class="text-center align-middle">
                              <div class="col-sm-12">
                                <b-dropdown variant="primary">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>
                                  <!-- <b-dropdown-item :disabled="!getRole('Editar')" :to="{ path: `/forms/estandares/identificacion-peligros-editar/${dato.id}` } ">Editar</b-dropdown-item>
                                   <b-dropdown-item :disabled="!getRole('Eliminar')" v-on:click="deleteIdentification(dato.id)">Eliminar</b-dropdown-item>-->
                                </b-dropdown>
                              </div>
                            </td>
                          </tr>

                       
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
    <Pagination ref="paginator" :companyID="companyID" @loading="(load) => (loading = load)" :search="search"
      @fetch="(items) => (themes = items)" />
  </div>
</template>

<script>
import Pagination from "./PlanningPagination";
import { dateFormat } from "@/utils/helpers/format"

export default {
  components: { Pagination },
  props: {
    companyID: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      themes: [],
      search: null,
      loading: true,
    };
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date)
    },

    print(evidence) {
      if (evidence) {
        window.location.href = evidence;
      }
    },

    /**
   * This method is used to knows if the user has the permission indicated
   * @param {String} name The name of the permission
   * @param {Array} roles the roles that permitted to access the action 
   * @returns {Boolean} true if the user has the permission indicated or false if no
   */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

  },
};
</script>
